import classNames from "classnames";

import {RequiredFieldsNoteProps} from "@/components/form/requiredFieldsNote/RequiredFieldsNote.types.ts";

import styles from "./RequiredFieldsNote.module.scss";

export const RequiredFieldsNote = ({spacing = "default", className, ...rest}: RequiredFieldsNoteProps) => (
  <p className={classNames(styles.note, styles[spacing], className)} {...rest}>
    <span className={styles.asterisk}>*</span> Indicates a required field
  </p>
);
